export default {
  name: 'repReview',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest('/crewconfig/annualreview/review/safetyrep', 'PUT', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `crews-crewid-safety-review-health-representative-review`, params: { crewid: data.crewid }, query: { sid: ctx.saveId } });
  }
}
